import React from 'react';
import { Button } from 'antd';
import {
  //SmartButton,
  SmartFormLabel,
  SmartRow,
  SmartScanner,
  SmartSpace,
} from 'components/Sales/Smart/SmartComponent';
import {
  message,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  //COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  //HTTP_STATUS_OK,
} from 'constants/config';
import {
  //editWarehousePostedTransfer,
  //fetchWarehousePostedTransferDetail,
  //fetchWarehousePostedTransferDetailByBatchNumber,
} from 'services/inventory';
import { fetchWarehouseLocationList } from 'services/warehouse';
import { playSound } from 'utils';
import { WHTActionType as WHTAction, WMSRecvStep } from './context';

type Props = ReduxStateProps & {
  //locationType: an enum or the location type should be in state;
};

const ScanLocation = (props: Props) => {
  const handleScannerChange = async (val: string) => {
    const { dispatch, state } = props;
    const lc = val.trim();

    if (!lc) return;
    console.log('v', lc);
    playSound('bell');
    dispatch({ type: WHTAction.SetLockScreen, params: true });
    try {
      const res = await fetchWarehouseLocationList(
        state.selectedWarehouse.warehouseId,
        false,
        val,
        0,
      );

      if (Array.isArray(res)) {
        if (res.length === 1) {
          console.log('location', res[0]);
          //setCurrentLocation(res[0]);
          dispatch({ type: WHTAction.SetRecvLocation, params: res[0] });
          dispatch({ type: WHTAction.SetWMSRecvStep, params: WMSRecvStep.ScanSku });
          //setCurrentStep(RecvStep.ScanItem);

          //if (isPatternCodeEnabled(state)) setCurrentPatternLocationVersion(currentPatternLocationVersion + 1);
        } else {
          playSound('error');

          if (res.length === 0) {
            message.error(`Not found location [${val}]`);
            /*if (isPatternCodeEnabled(state) && isCurrentLocationSet() && state.recvItems.length > 0) {
              //setCurrentStep(RecvStep.ScanItem);
              onClearCurrentLocation();
            }*/
          } else {
            message.error(`Found ${res.length} location(s) for [${val}]`);
          }
        }
      } else {
        playSound('error');
        message.error(`Format error, not found location [${val}]`);
      }
    } catch(e) {
      message.error({
        content: `Loaded location error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      dispatch({ type: WHTAction.SetLockScreen, params: false });
    }
  };

  return (<>
    <SmartSpace>
      <SmartFormLabel className="fs-18 mb-10 text-bold2 text-green-label">Scan Receive Location</SmartFormLabel>
      <SmartScanner
        //disabled={isFetching}
        isAutoFocus={1}
        placeholder="Input Location here"
        onChangeValue={handleScannerChange}
      />
      {/*<SmartButton
        className="mt-30"
        //onClick={}
        size="large"
        //style={{marginBottom: 0}}
        type="primary"
      >
        Use General
      </SmartButton>*/}
      <SmartRow className="mt-30" justify="space-between">
        <Button
          onClick={() => handleScannerChange('General')}
          type="text"
        >
          Use General
        </Button>
      </SmartRow>
    </SmartSpace>
  </>);
};

export default ScanLocation;
